import { apiGet } from './apiClient';
import { registerSessionReset, sessionTicket, assertSessionCurrent } from '../../../../utils/sessionLifecycle';

let cached = null, pending = null, refreshPending = null;
registerSessionReset(() => { cached = null; pending = null; refreshPending = null; });

// Share the raw directory, not a consumer's filtered people/agent projection.
export function readStaffDirectory({ force = false } = {}) {
  if (refreshPending) return refreshPending;
  if (force && pending) {
    const ticket = sessionTicket();
    const refresh = pending.catch(() => {}).then(() => {
      assertSessionCurrent(ticket);
      refreshPending = null;
      return readStaffDirectory({ force: true });
    }).finally(() => { if (refreshPending === refresh) refreshPending = null; });
    refreshPending = refresh;
    return refresh;
  }
  if (pending) return pending;
  const ticket = sessionTicket();
  if (!force && cached) return Promise.resolve(cached).then(response => { assertSessionCurrent(ticket); return response; });
  if (force) cached = null;
  const request = apiGet('/auth/get_all_users').then(response => {
    assertSessionCurrent(ticket);
    if (response.data?.success === false || !Array.isArray(response.data?.data)) {
      throw new Error(response.data?.message || 'Could not load the staff directory.');
    }
    cached = response;
    return response;
  }).finally(() => { if (pending === request) pending = null; });
  pending = request;
  return request;
}
